import paymentComponent from "@/components/payment/PaymentComponent.vue";
export default {
  name: "Payment",
  props: ["loggedUserData"],
  components: {
    payment: paymentComponent
  }
};